// Baut die Dropdown-Optionen für Status Gruppe und Einkaufsart der Flugplanungs-Sidebar
import {
  einkaufsartOptions,
  statusgruppeOptions,
  einkaufsartSelectableOptions,
  statusgruppeSelectableOptions,
  isEinkaufsartStatusgruppeVerboten,
} from '@/core/common/helpers/utils.js';

// Standardmäßig stehen nur die neuen, auswählbaren Werte zur Verfügung
// Hat der Reisetermin noch einen alten, nicht mehr auswählbaren Wert, wird dieser als
// zusätzliche Option angehängt, damit er im Dropdown sichtbar bleibt
function buildOptionsWithLegacy(selectable, full, currentValue) {
  if (currentValue == null || selectable.some(option => option.value === currentValue)) {
    return selectable;
  }
  const label = full.find(option => option.value === currentValue)?.text ?? currentValue;
  return [...selectable, { text: `${label}`, value: currentValue }];
}

// Baut die Status-Gruppe-Optionen und filtert die zur Einkaufsart unzulässigen Kombinationen aus
export function buildStatusgruppeOptions(einkaufsart, currentStatusgruppe) {
  const base = buildOptionsWithLegacy(
    statusgruppeSelectableOptions,
    statusgruppeOptions,
    currentStatusgruppe
  );
  return base.filter(
    opt =>
      opt.value == null ||
      opt.value === currentStatusgruppe ||
      !isEinkaufsartStatusgruppeVerboten(einkaufsart, opt.value)
  );
}

// Baut die Einkaufsart-Optionen und filtert die zur Status Gruppe unzulässigen Kombinationen aus
export function buildEinkaufsartOptions(statusgruppe, currentEinkaufsart) {
  const base = buildOptionsWithLegacy(einkaufsartSelectableOptions, einkaufsartOptions, currentEinkaufsart);
  return base.filter(
    opt =>
      opt.value == null ||
      opt.value === currentEinkaufsart ||
      !isEinkaufsartStatusgruppeVerboten(opt.value, statusgruppe)
  );
}
